import React from "react";
import { Paper, Typography } from "@mui/material";
import config from '../../Config/clientConfig.json'
import WSSelectField from "../../Components/Select/WSSelect";

const PaymentSettings = ({ control, setValue }: any) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Typography variant="h6" mb={2}>
        Payment Settings
      </Typography>

      {/* <WSTextField
        id="defaultPaymentMethod"
        name="defaultPaymentMethod"'CASH', 'CARD', 'UPI', 'BANK'
        label="Default Payment Method"
        control={control}
        setValue={setValue}
      /> */}

      <WSSelectField
        id="defaultPaymentMethod"
        control={control}
        name="defaultPaymentMethod"
        label={'Default Payment Method'}
        defaultValue={config.paymentTypeConfig.staticOptionData[0]}
        options={config.paymentTypeConfig.staticOptionData} />
    </Paper>
  );
};

export default PaymentSettings;